import { AccessGate, useCan } from '../../shared/access/AccessControls';
import React from 'react';
import TagForm from './TagForm';
import TagInfo from './TagInfo';
import Wrapper from '../../shared/components/Wrapper';
import { useEditMode } from '../../shared/hooks/useEditMode';
import EditModeSwitcher from '../../shared/components/EditModeSwitcher';
import { MLTag } from '../../shared/types/mediaLibraryTag';

interface ITagData {
  tag: MLTag;
}

const TagData: React.FC<ITagData> = ({ tag }) => {
  const canEdit = useCan('legacyFilerAdminOnly');
  const { edit, toggleEditMode, setEdit } = useEditMode();

  return (
    <Wrapper>
      <>
        <AccessGate action="legacyFilerAdminOnly"><EditModeSwitcher toggleEditMode={toggleEditMode} edit={edit} /></AccessGate>
        {(edit && canEdit && <TagForm tag={tag} setEdit={setEdit} />) || (
          <TagInfo tag={tag} />
        )}
      </>
    </Wrapper>
  );
};

export default TagData;
